import { ReactSVG } from "react-svg";

const SVGDualTone = ({ svgElement }) => {
  return <ReactSVG wrapper="span" src={svgElement} />;
};

export default SVGDualTone;
